<template>
  <div class="container-fluid">
    <div class="row h-100">
      <div class="col-sm p-0">
        <div class="__wraper_">
          <div class="_billing-address">
            <div class="container-page">
                    <div class="content">  
                     <div class="content-header">
                         <div class="_billingaddress_back" @click="goBack">
                            <svg xmlns="http://www.w3.org/2000/svg" fill='#1D3354' stroke="#1D3354" width="8.113" height="14.398" viewBox="0 0 8.113 14.398">
                                <g id="right-arrow" transform="translate(7.556 13.899) rotate(180)">
                                <path id="Path_220" data-name="Path 220" d="M.789,13.26a.446.446,0,0,1-.327.139.446.446,0,0,1-.327-.139.482.482,0,0,1,0-.67L5.884,6.7.135.809a.482.482,0,0,1,0-.67.455.455,0,0,1,.654,0L6.865,6.364a.482.482,0,0,1,0,.67Z" transform="translate(0 0)"/>
                                </g>
                            </svg>
                            <span>Back</span>
                         </div>
                            <span class="ml-5 pl-3">Change Billing Address</span>
                             <b-input @input="debouncedOnChange" v-model="search" class="col-md-3" placeholder="Search address"></b-input>
                     </div>
                    <AddressCard :mode = "'billing'" 
                    :billingDataGlobal='this.billingAddressGlobal || {}' 
                    :currentPage="currentPage"
                    :isFiltering="isFiltering"
                     />
                     <div class="row m-0 paginationCustom pt-3">
                          <div class="col-md-12 d-flex justify-content-center">
                            <b-pagination
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                            >
                            </b-pagination>
                          </div>
                      </div>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressCard from '@/components/settings/AddressCard.vue'
import {mapGetters} from 'vuex'
import _ from 'lodash'
export default {
  name: '',
  components: {
    AddressCard
  },
  data () {
    return {
      currentPage: 1,
      totalRows: 0,
      perPage: 4,
      searchItem: '',
      search: '',
      dataAddress: [],
      isFiltering: false
    }
  },
  mounted () {
    this.fetchAddressListVerivied()
  },
  computed: {
    ...mapGetters({
      // addressList: 'address/addressList',
      // isLoadingAddressList: 'address/isLoadingAddressList',

      // addressListFilter: 'address/addressListFilter',
      // isLoadingAddressListFilter: 'address/isLoadingAddressListFilter',

      addressListVerivied: 'address/addressListVerivied',

      addressListVeriviedFilter: 'address/addressListVeriviedFilter',

      billingAddressGlobal: 'address/billingAddressGlobal'
    }),
    debouncedOnChange () {
      return _.debounce(this.filterOnChange, 700)
    }
  },
  methods: {
    filterOnChange () {
      this.searchItem = this.search
    },
    async fetchAddressListVeriviedFilter (payload) {
      this.isFiltering = true
      await this.$store.dispatch('address/FETCH_ALL_ADDRESS_VERIVIED_FILTER', payload)
    },
    async fetchAddressListVerivied () {
      this.isFiltering = false
      const payload = {
        page: this.currentPage,
        perPage: this.perPage
      }
      await this.$store.dispatch('address/FETCH_ALL_ADDRESS_VERIVIED', payload)
    },
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  },
  watch: {
    addressListVerivied (data) {
      if (data) {
        this.totalRows = data.totalRecords
      }
    },
    addressListVeriviedFilter (data) {
      if (data) {
        this.totalRows = data.totalRecords
      }
    },
    currentPage (data) {
      if (data) {
        if (this.searchItem) {
          const payload = {
            page: this.currentPage,
            filter: 'company-name',
            key: this.searchItem,
            perPage: this.perPage
          }
          this.fetchAddressListVeriviedFilter(payload)
        } else {
          this.fetchAddressListVerivied()
        }
      }
    },
    searchItem (data) {
      if (data) {
        const payload = {
          page: 1,
          filter: 'company-name',
          key: data,
          perPage: this.perPage
        }
        this.fetchAddressListVeriviedFilter(payload)
      } else {
        this.fetchAddressListVerivied()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/billingAddress/index.vue